import React from 'react';
import Swiper from 'react-id-swiper';

import styled from 'styled-components';
import { colors } from '../utils/colors';
import PrevButton from './PrevButton';
import NextButton from './NextButton';

import Bolo3 from './Bolo3';
import Clave from './Clave';
import Copy from './Copy';
import ManchetaDesktop from './ManchetaDesktop';
import Antetitulo from './Antetitulo';
import Titulo from './Titulo';


import Sharer from './Sharer';
import Footer from './Footer';


import { data } from '../data/data';
import { titulos } from '../data/titulos';


import '../styles/Swiper.css';


const Center = styled.div`
	margin: 0 auto;
	text-align: center;
	padding-top: 2em;
	padding: 1em;
   background: ${colors.black};
`;


// COMPONENTE

class Sw extends React.Component {
	state = {
		rando: -2
	}

	constructor(props) {
		super(props)
		this.swiper = null
	}

	refSwiper = React.createRef();

	componentDidUpdate() {
		if (this.swiper) this.swiper.slideNext()
	}

	onSlideChange = () => {
		this.setState({ rando: `${Math.floor((Math.random() * 5) + 0)}` })
	};

	render() {
		const slides = {
			height: `${this.props.height}px`,
			width: `${this.props.width}px`,
			background: `${colors.black}`
		};


		const images = {
			maxHeight: `${this.props.height / 1.5 - 50}px`,
			maxWidth: `${this.props.width}px`,
			transform: `rotate(${this.state.rando}deg)`,
			transition: 'transform 7s'
		}

		const params = {
			on: {
				slideChange: this.onSlideChange
			},
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				prevEl: '.prev',
				nextEl: '.next'
			},
			renderPrevButton: () => (
				<button className="prev"><PrevButton type="button" className="prev" width={this.props.width} height={this.props.height} contenido="← Anterior" /></button>
			),
			renderNextButton: () => (
				<button className="next"><NextButton type="button"  className="next" width={this.props.width} height={this.props.height} contenido="Siguiente →" /></button>
			),
			loop: false
		};

		return (
			<Swiper {...params} ref={node => this.swiper ? this.swiper = node.swiper : ''}>
				{/* INTRO */}

				<div style={slides}>
					<div style={{
						...slides, display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						background: 'url("./img/fotos/alta/intro.jpg") no-repeat',
						backgroundPosition: '50% 50%',
						backgroundSize: 'cover',
						backgroundColor: colors.black
					}}>
						<div>

							<ManchetaDesktop width={this.props.width} height={this.props.height} />
							<Antetitulo contenido={titulos.antetitulo.toUpperCase()} />
							<Titulo contenido={titulos.titulo.toUpperCase()} />
							<Clave contenido={titulos.subtitulo} />
							<Antetitulo contenido={titulos.texto.toUpperCase()} />

						</div>

					</div>
				</div>

				{/* SLIDES */}
				{data.map((x, i) => {
					return (
						<div style={slides} key={'foto_grande' + i}>

							<img
								style={images}
								src={"./img/fotos/alta/" + (i + 1) + ".jpg"}
								alt={i + 1}
							/>
							<Center>
								<Copy contenido={`${x.body}`} />
							</Center>
						</div>
					)
				})
				}

				{/* OUTRO */}
				<div style={slides}>
					<div style={{
						...slides, display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						background: 'url("./img/fotos/alta/intro.jpg") no-repeat',
						backgroundPosition: '50% 50%',
						backgroundSize: 'cover',
						backgroundColor: colors.black
					}}>
						<div>
							<Clave contenido='COMPARTE' />
							<Sharer />
							<Footer />
						</div>
					</div>
				</div>


			</Swiper>
		);
	}
}

export default Sw;



// WEBPACK FOOTER //
// ./src/components/Sw.js